import React from "react";
import { SocialData } from "../../data/social";
function SocialContact() {
    const data = SocialData;
  return (
    <div className="flex justify-center items-center">
        {data.map ((item) => {
          return (
            <a href={item.link} target="_blank" rel="noreferrer">
              <div className=" p-2 m-2 cursor-pointer">
                <img src={item.icon} className=" h-8 md:h-10" alt=""/>
              </div>
            </a>
          );
        })} 
    </div>
  );
}

export default SocialContact;